import { resolveMediaUrl } from './media';
import { initialForm } from '../services/playerService';
import { ADD_ONS } from '../constants/profileAddOns';

export { resolveMediaUrl } from './media';

const placeholderHints = ['placeholder', 'placehold', 'dummyimage', 'player-placeholder', 'profile-placeholder'];
const isPlaceholderImage = (value) =>
  placeholderHints.some((hint) => value.toLowerCase().includes(hint));

export const toDateInputValue = (value) => {
  if (!value) return '';

  if (
    typeof value === 'string' &&
    /^\d{4}-\d{2}-\d{2}$/.test(value)
  ) {
    return value;
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value).slice(0, 10);
  }

  return date.toISOString().slice(0, 10);
};

export const sanitizeProfilePhoto = (value) => {
  if (!value || typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed || isPlaceholderImage(trimmed)) return '';
  return resolveMediaUrl(trimmed);
};

export const getProfilePhotoSrc = (profile = {}) =>
  sanitizeProfilePhoto(
    profile.personal?.photoUrl ||
      profile.media?.profilePhoto ||
      profile.profilePhoto ||
      profile.profilePhotoUrl ||
      profile.profilePhotoURL ||
      profile.photoUrl ||
      profile.image ||
      profile.avatar ||
      ''
  );

export const normalizeProfile = (profile = {}) => {
  const normalizedMedia = { ...initialForm.media, ...(profile.media || {}) };
  const normalizedPersonal = {
    ...initialForm.personal,
    ...(profile.personal || {}),
    dob: toDateInputValue(profile?.personal?.dob || profile?.dob),
  };
  const resolvedPhotoUrl = getProfilePhotoSrc({
    ...profile,
    personal: normalizedPersonal,
    media: normalizedMedia,
  });
  const resolvedMedia = {
    ...normalizedMedia,
    profilePhoto: sanitizeProfilePhoto(normalizedMedia.profilePhoto),
    coverImage: resolveMediaUrl(normalizedMedia.coverImage),
  };

  const addOns = { ...initialForm.addOns, ...(profile.addOns || {}) };
  const legacyExtras = Array.isArray(profile.extraFeatures) ? profile.extraFeatures : [];
  Object.entries(ADD_ONS).forEach(([key, label]) => {
    if (legacyExtras.includes(label)) {
      addOns[key] = true;
    }
  });

  return {
    ...initialForm,
    ...profile,
    personal: { ...normalizedPersonal, photoUrl: resolvedPhotoUrl },
    skills: { ...initialForm.skills, ...(profile.skills || {}) },
    bio: { ...initialForm.bio, ...(profile.bio || {}) },
    team: { ...initialForm.team, ...(profile.team || {}) },
    media: resolvedMedia,
    addOns,
    highlights: profile.highlights || [],
    achievements: profile.achievements || [],
    milestones: profile.milestones || [],
    awards: profile.awards || [],
    badges: profile.badges || [],
    level: { ...initialForm.level, ...(profile.level || {}) },
    matchParticipation: {
      ...initialForm.matchParticipation,
      ...(profile.matchParticipation || {}),
      summary: {
        ...initialForm.matchParticipation.summary,
        ...((profile.matchParticipation || {}).summary || {}),
      },
    },
    preferences: { ...initialForm.preferences, ...(profile.preferences || {}) },
    mediaGallery: profile.mediaGallery || [],
    extraFeatures: profile.extraFeatures || Object.values(ADD_ONS).filter((label, idx) => addOns[Object.keys(ADD_ONS)[idx]]),
  };
};
